<template>
  <fragment>
    <h1 v-if="size === 1"><slot></slot></h1>
    <h2 v-if="size === 2"><slot></slot></h2>
    <h3 v-if="size === 3"><slot></slot></h3>
    <h4 v-if="size === 4"><slot></slot></h4>
  </fragment>
</template>

<script>
export default {
  name: "Headline",
  props: {
    size: {
      type: Number,
      required: true,
    },
  },
};
</script>
